"use strict";

import Modal from 'bootstrap/js/dist/modal';

function openModalFromUrl() {
    const id = new URLSearchParams(location.search).get('modal-id');
    if (!id) return;
    const el = document.getElementById(id);
    if (el && el.classList.contains('modal')) {
        Modal.getOrCreateInstance(el).show();
    }
}

export function init() {
    let modalTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="modal"]'))
    let modalList = modalTriggerList.map(function (modalTriggerEl) {
        return new Modal(modalTriggerEl);
    });

    /*open modal on page load*/
    let modalId = _config.modalId;
    if(modalId && !sessionStorage.getItem(modalId)) {
        let modalShow = new Modal(document.getElementById(modalId), {})
        modalShow.show()
    }

    openModalFromUrl();
}